module.exports = __webpack_public_path__ + "static/img/wallpaper-mb5.1aec1ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wallpaper-mb5.jpg
// module id = 1+zK
// module chunks = 1